/* Conversion Dude - homepage sticky CTA.
   Slides the bottom bar in once the visitor has scrolled past the hero
   (data-offset px), and reserves space at the end of the page so the footer
   is never hidden behind it. Re-runs on theme editor section loads. */
(function () {
  function init(bar) {
    if (bar.dataset.ready) return;
    bar.dataset.ready = '1';
    var offset = parseInt(bar.getAttribute('data-offset'), 10) || 400;
    var inEditor = !!window.Shopify && !!window.Shopify.designMode;
    var always = bar.getAttribute('data-always-editor') === 'true' && inEditor;
    var shown = false;

    function setPad() {
      var h = shown ? bar.offsetHeight : 0;
      document.body.style.paddingBottom = h ? h + 'px' : '';
    }
    function update() {
      var next = always || window.scrollY > offset;
      if (next !== shown) {
        shown = next;
        bar.classList.toggle('is-visible', shown);
        setPad();
      }
    }
    window.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', setPad);
    update();
  }
  function all(root) { (root || document).querySelectorAll('[data-cdhp-sticky]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { all(); });
  else all();
  document.addEventListener('shopify:section:load', function (e) { all(e.target); });
})();
